import { ReferralsourceFilterOptions } from '../../enums/filters-and-searchs/referral.source.filter.options';

export const ReferralSourceOptionsDetail = new Map<number, string>([
    [ReferralsourceFilterOptions.None, 'None'],
    [ReferralsourceFilterOptions.Deleted, 'Deleted Referral Source']
]);
